"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdownButtons = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var AttributeDropdownButtonsWrapped = function (_a) {
    var applyDisabled = _a.applyDisabled, intl = _a.intl, onApplyButtonClicked = _a.onApplyButtonClicked, onCloseButtonClicked = _a.onCloseButtonClicked;
    var cancelText = intl.formatMessage({ id: "gs.list.cancel" });
    var applyText = intl.formatMessage({ id: "gs.list.apply" });
    return (react_1.default.createElement("div", { className: "gd-attribute-filter-actions" },
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-button-secondary gd-button-small cancel-button s-cancel", onClick: onCloseButtonClicked, value: cancelText, title: cancelText }),
        react_1.default.createElement(sdk_ui_kit_1.Button, { disabled: applyDisabled, className: "gd-button-action gd-button-small s-apply", onClick: onApplyButtonClicked, value: applyText, title: applyText })));
};
exports.AttributeDropdownButtons = react_intl_1.injectIntl(AttributeDropdownButtonsWrapped);
//# sourceMappingURL=AttributeDropdownButtons.js.map